<template>
    <div class="app-header-search">
        <nuxt-link
            type="button"
            aria-label="Search"
            class="px-2 h-full inline-flex items-center justify-center rounded-md text-white"
            to="/search"
        >
            <span class="sr-only">Open search</span>
            <svg
                class="h-7 w-7 sm:h-8 sm:w-8"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z"
                    clip-rule="evenodd"
                />
            </svg>
        </nuxt-link>
    </div>
</template>

<script>
export default {
    name: 'AppHeaderSearch',
};
</script>
